// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5f8cbf34","762":"641dec55"}[chunkId] + ".chunk.js";
};